import React, { Component } from "react";
import { withNavigation } from "../withNavigation";
import "../styles/adminrevenue.css";

class AdminRevenue extends Component {
    state = {
        totalMatches: 0,
        totalEntry: 0,
        todayEntry: 0,
        liveMatches: 0,
        onlineUsers: 0
    };

    componentDidMount() {
        const admin = localStorage.getItem("adminToken");

        if (!admin) {
            this.props.navigate("/admin", { replace: true });
        }

        fetch("https://api.hi-bigame.online/admin/revenue")
            .then((res) => res.json())
            .then((data) => {
                this.setState({
                    totalMatches: data.totalMatches || 0,
                    totalEntry: data.totalEntry || 0,
                    todayEntry: data.todayEntry || 0
                })
            });

        this.getLiveMatches();
        this.timer = setInterval(() => { this.getLiveMatches(); }, 2000);

        this.getOnlineUsers();
        this.userTimer = setInterval(() => { this.getOnlineUsers(); }, 2000);
    }


    getOnlineUsers = () => {
        fetch("https://api.hi-bigame.online/admin/online-users")
            .then((res) => res.json())
            .then((data) => {
                this.setState({ onlineUsers: data.onlineUsers || 0 });
            });
    };


    componentWillUnmount() {
        clearInterval(this.timer);
        clearInterval(this.userTimer);
    }

    getLiveMatches = () => {
        fetch("https://api.hi-bigame.online/admin/live-matches")
            .then((res) => res.json())
            .then((data) => {
                this.setState({ liveMatches: data.liveMatches || 0 });
            });
    };


    goBack = () => {
        this.props.navigate("/admin-dashboard");
    };

    render() {
        const revenue = this.state.totalEntry * 0.20;
        const todayRevenue = this.state.todayEntry * 0.20;

        return (
            <div>

                <div className="admin-revenue-container">

                    <h1 className="admin-revenue-title">💰 Revenue Panel</h1>

                    <button className="admin-revenue-back" onClick={this.goBack}> Back</button>

                    <div className="revenue-card">

                        <div className="revenue-item">         Total Matches: {this.state.totalMatches}</div>

                        <div className="revenue-item red">      🔴 Live Matches: {this.state.liveMatches}</div>

                        <div className="revenue-item green">    🟢 Online Users: {this.state.onlineUsers}</div>

                        <div className="revenue-item">           Total Entry: ₹{this.state.totalEntry}</div>

                        <div className="revenue-item highlight"> Revenue (20%): ₹{revenue}</div>

                        <div className="revenue-item today">     📅 Today Revenue: ₹{todayRevenue}</div>

                    </div>

                </div>

            </div>
        );
    }
}

export default withNavigation(AdminRevenue);